import { LineChartWidgetProps } from './types';
import { getLineChartOptions } from './getLineChartOptions';
import { Chart } from '../categoricalCharts/EChart';
import { Maybe } from '@ardoq/api-types';

export const LineChartWidget = (
  props: LineChartWidgetProps & { dashboardContainerRef: Maybe<HTMLDivElement> }
) => <Chart chartOptions={getLineChartOptions(props)} />;
